// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { HttpClientInstance } from '@toggl/sync/http';
import type {
  AutomationsAutomation,
  AutomationsCreateAutomationRequest,
  AutomationsRunAutomationRequest,
  AutomationsUpdateAutomationRequest,
} from '../types';

export async function getAutomationsList(
  httpClient: HttpClientInstance,
  workspace_id: number,
  opening_id: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .get(`workspaces/${workspace_id}/openings/${opening_id}/automations`, {
      signal,
    })
    .json<AutomationsAutomation[]>();
  return response;
}

export async function postAutomations(
  httpClient: HttpClientInstance,
  workspace_id: number,
  opening_id: number,
  stage_id: number,
  data: AutomationsCreateAutomationRequest,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(
      `workspaces/${workspace_id}/openings/${opening_id}/stages/${stage_id}/automations`,
      { signal, json: data }
    )
    .json<AutomationsAutomation>();
  return response;
}

export async function runAutomations(
  httpClient: HttpClientInstance,
  workspace_id: number,
  opening_id: number,
  stage_id: number,
  automation_id: number,
  data: AutomationsRunAutomationRequest,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(
      `workspaces/${workspace_id}/openings/${opening_id}/stages/${stage_id}/automations/${automation_id}`,
      { signal, json: data }
    )
    .json<unknown>();
  return response;
}

export async function deleteAutomations(
  httpClient: HttpClientInstance,
  workspace_id: number,
  opening_id: number,
  stage_id: number,
  automation_id: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .delete(
      `workspaces/${workspace_id}/openings/${opening_id}/stages/${stage_id}/automations/${automation_id}`,
      { signal }
    )
    .json<unknown>();
  return response;
}

export async function updateAutomations(
  httpClient: HttpClientInstance,
  workspace_id: number,
  opening_id: number,
  stage_id: number,
  automation_id: number,
  data: Partial<AutomationsUpdateAutomationRequest>,
  signal?: AbortSignal
) {
  const response = await httpClient
    .patch(
      `workspaces/${workspace_id}/openings/${opening_id}/stages/${stage_id}/automations/${automation_id}`,
      { signal, json: data }
    )
    .json<AutomationsAutomation>();
  return response;
}
